(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fpa-info-center-subpage-6"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('fpa-image-section-{{ section.id }}');
  if (!root) return;

  const slider = root.querySelector('[data-image-slider]');
  const prevBtn = root.querySelector('[data-slider-prev]');
  const nextBtn = root.querySelector('[data-slider-next]');
  if (!slider || !prevBtn || !nextBtn) return;

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  const amount = () => slider.clientWidth * 0.9;

  prevBtn.addEventListener('click', () => {
    if (!isMobile()) return;
    slider.scrollBy({ left: -amount(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', () => {
    if (!isMobile()) return;
    slider.scrollBy({ left: amount(), behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
